import { inputAnatomy } from '@chakra-ui/anatomy'
import { textStyles } from '../foundations/textStyles'

import {
  createMultiStyleConfigHelpers,
  defineStyle,
} from '@chakra-ui/styled-system'

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(inputAnatomy.keys)

const baseStyle = definePartsStyle({
  addon: defineStyle({
    color: 'neutral.900',
    borderRadius: 'md',
  }),
  field: defineStyle({
    color: 'neutral.900',
    borderRadius: 'md',
  }),
  element: defineStyle({
    color: 'neutral.900',
  }),
})

const size = {
  xs: defineStyle({
    ...textStyles.xs,
  }),
  sm: defineStyle({
    ...textStyles['sm'],
  }),
  md: defineStyle({
    ...textStyles['md'],
  }),
  lg: defineStyle({
    ...textStyles['lg'],
  }),
}

const sizes = {
  xs: definePartsStyle({
    addon: size.xs,
    element: size.xs,
    field: size.xs,
  }),
  sm: definePartsStyle({
    addon: size.sm,
    element: size.sm,
    field: size.sm,
  }),
  md: definePartsStyle({
    addon: size.md,
    element: size.md,
    field: size.md,
  }),
  lg: definePartsStyle({
    addon: size.lg,
    element: size.lg,
    field: size.lg,
  }),
}

export const Input = defineMultiStyleConfig({
  baseStyle,
  sizes,
  defaultProps: {
    variant: 'outline',
  },
})
